import _ from 'lodash'
import axios from 'axios'
import { previewDmakerTemplate } from '@/api/creative/template'
import { previewDmakerCustom } from '@/api/creative/custom'
import { previewGmakerProject } from '@pt/api/gmaker/project.js'
import { previewGmakerTemplate } from '@/api/gmaker/template.js'

/**
 * cookApiParams
 * @param {{page: string, id: number}} param0
 */
export const getPreviewApiRequest = ({ page, id, skinId, templateType }) => {
  const previewProject = () => {
    return {
      params: {
        id,
        silent: 1,
      },
      request: previewGmakerProject,
    }
  }
  const commonTemplateCustomApiUtils = {
    'common-template-dco': previewProject,
    'common-template-custom': previewProject,
    'common-template-multi-custom': previewProject,
  }

  const templateApiUtils = {
    template: () => {
      if (templateType === 'gm') {
        return {
          params: {
            id,
            silent: 1,
          },
          request: previewGmakerTemplate,
        }
      }
      return {
        params: {
          id,
          silent: 1,
        },
        request: previewDmakerTemplate,
      }
    },
    'common-template': () => {
      return {
        params: {
          id,
          skin_id: skinId,
          silent: 1,
        },
        request: previewGmakerTemplate,
      }
    },
  }

  const templateCustomApiUtils = {
    dco: () => {
      return {
        params: {
          id,
          silent: 1,
        },
        request: previewDmakerCustom,
      }
    },

    custom: () => {
      return {
        params: {
          id,
          silent: 1,
        },
        request: previewDmakerCustom,
      }
    },

    'multi-custom': () => {
      return {
        params: {
          id,
          silent: 1,
        },
        request: previewDmakerCustom,
      }
    },
  }

  const apiUtils = {
    ...templateApiUtils,
    ...templateCustomApiUtils,
    ...commonTemplateCustomApiUtils,
  }

  return apiUtils[page]() || null
}

let source = null
const CancelToken = axios.CancelToken

export default async function preview({ state, commit }) {
  // 预览页面的只读模式使用基础包信息接口中的链接
  if (state.isReadonly) {
    commit('updatePreviewUrl', state.templateConfig.preview_url)
    return
  }

  if (source) {
    console.log('取消上一次预览接口请求')
    source.cancel('cancel request')
  }

  source = CancelToken.source()
  const previewLanguage = state.previewLanguage
  const apiParams = getPreviewApiRequest({
    page: state.page,
    id: state.id,
    skinId: state.skinId,
    templateType: state.templateType,
  })

  try {
    commit('updatePreparingPreview', true)

    const params = { ...apiParams.params, lang: previewLanguage }

    const res = await apiParams.request(params, {
      cancelToken: source.token,
    })
    // 开发环境与测试环境给的 URL 应该是 http 的
    let previewUrl = _.get(res, 'data.data.preview_url')

    // 如果请求时带了语言，那么也需要补上语言（用于代码字预览，代码字读取脚本会先去查看 URL 上是否有 lang 字段，如果有则使用该语言预览）
    // 支持实时预览的包 URL 不能带 lang 查询参数，因为如果 lang 有值，postMessage 过去的语言优先级没有 URL 上的 lang 字段高
    if (previewLanguage && !state.canLivePreview) {
      previewUrl = `${previewUrl}?lang=${previewLanguage}`
    }

    // 预览链接 preview_url
    if (previewUrl) {
      commit('updatePreviewUrl', previewUrl)
      commit('updatePreparingPreview', false)
    } else {
      commit('updatePreparingPreview', false)
    }
  } catch (error) {
    commit('updatePreparingPreview', false)
    console.log(error)
  }
}
